import { signal } from "@preact/signals-react";
import { Window } from "@progress/kendo-react-dialogs";

export const showCommentsWindow = signal(false);
export const commentsData = signal(null);
export const commentsFieldName = signal("");

export const CommentsViewWindow = () => {
  if (!showCommentsWindow.value) return null;

  const formatDateTimeForDisplay = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;

    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();

    return `${month}/${day}/${year}, ${hours}:${minutes} ${ampm}`;
  };

  const breakLines = (text, maxLen = 45) => {
    if (!text) return "";
    const regex = new RegExp(`.{1,${maxLen}}`, "g");
    return text.match(regex).join("\n");
  };

  return (
    <Window
      title={`${commentsFieldName.value}`}
      onClose={() => {
        showCommentsWindow.value = false;
        commentsFieldName.value = "";
      }}
      initialHeight={500}
      initialWidth={500}
    >
      <div style={{ padding: "20px" }}>
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {commentsData.value?.map((c, i) => (
            <li
              key={c.name + "_" + i}
              style={{ marginBottom: 10, borderBottom: "1px solid #eee", paddingBottom: 12 }}
            >
              <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                <span style={{ fontWeight: 600, marginRight: 8 }}>{c.name || "User"}</span>
                <span style={{ color: "#888", fontSize: 12 }}>
                  {formatDateTimeForDisplay(c.date)}
                </span>
              </div>
              <div style={{ fontSize: 15, whiteSpace: "pre-line" }}>{breakLines(c.comment)}</div>
            </li>
          ))}
        </ul>
      </div>
    </Window>
  );
};
